import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-container-mobile mx-3 d-block d-lg-none" }
const _hoisted_2 = { class: "timeline-title-mobile heading" }
const _hoisted_3 = { class: "d-flex mb-1" }
const _hoisted_4 = { class: "timeline-content-mobile pb-2" }
const _hoisted_5 = { class: "timeline-text-mobile" }
const _hoisted_6 = { class: "custom-badge-mobile badge-train-mobile" }
const _hoisted_7 = { class: "d-flex mb-1" }
const _hoisted_8 = { class: "timeline-content-mobile pb-2" }
const _hoisted_9 = { class: "timeline-text-mobile" }
const _hoisted_10 = { class: "custom-badge-mobile badge-transfer-mobile" }
const _hoisted_11 = { class: "d-flex mb-1" }
const _hoisted_12 = { class: "timeline-content-mobile pb-2" }
const _hoisted_13 = { class: "timeline-text-mobile" }
const _hoisted_14 = { class: "custom-badge-mobile badge-stay-mobile" }
const _hoisted_15 = { class: "d-flex mb-1" }
const _hoisted_16 = { class: "timeline-content-mobile pb-2" }
const _hoisted_17 = { class: "timeline-text-mobile" }
const _hoisted_18 = { class: "custom-badge-mobile badge-transfer-mobile" }
const _hoisted_19 = { class: "d-flex mb-1" }
const _hoisted_20 = { class: "timeline-content-mobile pb-2" }
const _hoisted_21 = { class: "timeline-text-mobile" }
const _hoisted_22 = { class: "custom-badge-mobile badge-train-mobile" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = { class: "timeline-content-mobile" }
const _hoisted_25 = { class: "timeline-text-mobile mb-0" }
const _hoisted_26 = { class: "timeline-section d-none d-lg-block" }
const _hoisted_27 = { class: "timeline-section-title body-strong" }
const _hoisted_28 = { class: "timeline-track" }
const _hoisted_29 = { class: "point" }
const _hoisted_30 = { class: "label-bottom subcaption" }
const _hoisted_31 = { class: "segment" }
const _hoisted_32 = { class: "badge-top" }
const _hoisted_33 = { class: "custom-badge badge-train m-0 p-1 px-2 subcaption-strong" }
const _hoisted_34 = { class: "point" }
const _hoisted_35 = { class: "label-bottom subcaption" }
const _hoisted_36 = { class: "segment" }
const _hoisted_37 = { class: "badge-top" }
const _hoisted_38 = { class: "custom-badge badge-transfer m-0 p-1 px-2 subcaption-strong" }
const _hoisted_39 = { class: "point" }
const _hoisted_40 = { class: "label-bottom subcaption" }
const _hoisted_41 = { class: "segment" }
const _hoisted_42 = { class: "badge-top" }
const _hoisted_43 = { class: "custom-badge badge-stay m-0 p-1 px-2 subcaption-strong" }
const _hoisted_44 = { class: "point" }
const _hoisted_45 = { class: "label-bottom subcaption" }
const _hoisted_46 = { class: "segment" }
const _hoisted_47 = { class: "badge-top" }
const _hoisted_48 = { class: "custom-badge badge-transfer m-0 p-1 px-2 subcaption-strong" }
const _hoisted_49 = { class: "point" }
const _hoisted_50 = { class: "label-bottom subcaption" }
const _hoisted_51 = { class: "segment" }
const _hoisted_52 = { class: "badge-top" }
const _hoisted_53 = { class: "custom-badge badge-train m-0 p-1 px-2 subcaption-strong" }
const _hoisted_54 = { class: "point" }
const _hoisted_55 = { class: "label-bottom subcaption" }

import { computed } from "vue";
import { useStore } from "vuex";

import TrainSvgIcon from "./svg/trainSvgIcon.vue";
import TransferSvgIcon from "./svg/transferSvgIcon.vue";
import SkiSvgIcon from "./svg/skiSvgIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TNETimeLine',
  setup(__props) {

const store = useStore();

const content = computed(() => store.state.content);

const trainStationName = computed(() => {
  return content.value['planning_traintimeline_station'][store.state.flightOrigin]?.short || "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(content.value.planning_traintimeline_title), 1),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-solid-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_arrival_1), 1),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_arrival_2) + " " + _toDisplayString(trainStationName.value), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_departure_name), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-dotted-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_arrival_3), 1),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_arrival_4), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(TransferSvgIcon, {
              color: "var(--primary-black)",
              width: 16,
              height: 16,
              fill: "var(--primary-black)",
              stroke: "var(--primary-black)"
            }),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_arrival_transfer), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-solid-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_checkin_1), 1),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_checkin_2), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(SkiSvgIcon, {
              color: "var(--primary-white)",
              width: 16,
              height: 16,
              fill: "var(--primary-white)",
              stroke: "var(--primary-white)"
            }),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_stay), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-dotted-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_ski_1), 1),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_ski_2), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(TransferSvgIcon, {
              color: "var(--primary-black)",
              width: 16,
              height: 16,
              fill: "var(--primary-black)",
              stroke: "var(--primary-black)"
            }),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_transfer_return), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-solid-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_return_1), 1),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_return_2), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_return_name), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile" })
        ], -1)),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_return_3), 1),
            _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_return_4) + " " + _toDisplayString(trainStationName.value), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, _toDisplayString(content.value.planning_traintimeline_title), 1),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "circle" }, null, -1)),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_arrival_1), 1),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(_toDisplayString(content.value.planning_traintimeline_arrival_2) + " " + _toDisplayString(trainStationName.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "segment-solid" }, null, -1)),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, [
              _createVNode(TrainSvgIcon, {
                color: "var(--primary-blue)",
                width: 16,
                height: 16,
                fill: "var(--primary-blue)",
                stroke: "var(--primary-blue)"
              }),
              _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_departure_name), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "circle" }, null, -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_arrival_3), 1),
            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(_toDisplayString(content.value.planning_traintimeline_arrival_4), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "segment-dotted" }, null, -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("span", _hoisted_38, [
              _createVNode(TransferSvgIcon, {
                color: "var(--primary-black)",
                width: 16,
                height: 16,
                fill: "var(--primary-black)",
                stroke: "var(--primary-black)"
              }),
              _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_arrival_transfer), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "circle filled" }, null, -1)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_checkin_1), 1),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(_toDisplayString(content.value.planning_traintimeline_checkin_2), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "segment-solid" }, null, -1)),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("span", _hoisted_43, [
              _createVNode(SkiSvgIcon, {
                color: "var(--primary-white)",
                width: 16,
                height: 16,
                fill: "var(--primary-white)",
                stroke: "var(--primary-white)"
              }),
              _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_stay), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "circle filled" }, null, -1)),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_ski_1), 1),
            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(_toDisplayString(content.value.planning_traintimeline_ski_2), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "segment-dotted" }, null, -1)),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("span", _hoisted_48, [
              _createVNode(TransferSvgIcon, {
                color: "var(--primary-black)",
                width: 16,
                height: 16,
                fill: "var(--primary-black)",
                stroke: "var(--primary-black)"
              }),
              _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_transfer_return), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "circle" }, null, -1)),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_return_1), 1),
            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(_toDisplayString(content.value.planning_traintimeline_return_2), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "segment-solid" }, null, -1)),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("span", _hoisted_53, [
              _createVNode(TrainSvgIcon, {
                color: "var(--primary-blue)",
                width: 16,
                height: 16,
                fill: "var(--primary-blue)",
                stroke: "var(--primary-blue)"
              }),
              _createTextVNode(" " + _toDisplayString(content.value.planning_traintimeline_return_name), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "circle" }, null, -1)),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("strong", null, _toDisplayString(content.value.planning_traintimeline_return_3), 1),
            _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(_toDisplayString(content.value.planning_traintimeline_return_4) + " " + _toDisplayString(trainStationName.value), 1)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})